import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { FaArrowRight } from 'react-icons/fa'

import { Container } from './styles'

import FormEndereco from '../../components/FormEndereco'

export default function ({ callback }) {
    const [initialValues, setInitialValues] = useState({
        cep: '',
        uf: '',
        cidade: '',
        bairro: '',
        rua: '',
        numero: '',
        complemento: ''
    })

    useEffect(() => {
        const storageData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))

        if(storageData?.endereco) {
            setInitialValues(storageData.endereco)
        }
    }, [])

    function handleSubmit(values) {
        const storageData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))

        values.uf = values.uf.value
        values.cidade = values.cidade.value

        localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify({ 
            ...storageData, 
            endereco: values 
        }))
        
        toast.success('Dados salvos! Por favor, continue o preenchimento.')
        
        callback()
    }

    return (
        <Container>
            <FormEndereco 
                onSubmit={handleSubmit} 
                storageRecover={{ storage: 'sindmepa-associacao-temp-data', prop: 'endereco' }}
                defaultValues={initialValues}
                buttonContent={(
                    <>
                        Continuar
                        <FaArrowRight />
                    </>
                )}
            />
        </Container>
    )
}
